import { render, staticRenderFns } from "./BancoField.vue?vue&type=template&id=ec8ee3ba&scoped=true&"
import script from "./BancoField.vue?vue&type=script&lang=js&"
export * from "./BancoField.vue?vue&type=script&lang=js&"
import style0 from "./BancoField.vue?vue&type=style&index=0&id=ec8ee3ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8ee3ba",
  null
  
)

export default component.exports